import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateSprintErrorMessageData } from '../widgets/sprintinfo-widget/sprintinfo-widget.component';

@Component({
  selector: 'app-create-sprint-error-message',
  templateUrl: './create-sprint-error-message.component.html',
  styleUrls: ['./create-sprint-error-message.component.scss']
  })
export class CreateSprintErrorMessageComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CreateSprintErrorMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateSprintErrorMessageData) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
